import React from "react";
import { useEffect, useRef } from "react";
/**
 * 元素是否在在视空显示
 */
interface Props {
	onVisible: (visible: boolean) => void;
	className?: string;
	rootMargin?: string;
}
function Observer(props: Props) {
	const targetRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleIntersection = (entries: IntersectionObserverEntry[]) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					props.onVisible(true);
				} else {
					props.onVisible(false);
				}
			});
		};

		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: props.rootMargin ? props.rootMargin : "0px",
			threshold: 1,
		});

		if (targetRef.current) {
			observer.observe(targetRef.current);
		}

		return () => {
			observer.disconnect();
		};
	}, []);

	return <div ref={targetRef} className={props.className}></div>;
}
export default React.memo(Observer);
